<template lang="pug">
  .d-flex.align-center.justify-center.fill-height.flex-column
    template(v-if="isFetching")
      v-progress-circular(:width="3" :size="40" color="primary" indeterminate)
      .text-md.mt-2 Fetching Quotation Request...
    template(v-else-if="isError")
      v-icon(color="danger500") mdi-alert-circle-outline
      .text-md.danger500--text.mt-2 {{ errorMessage }}
</template>

<script>
export default {
  data() {
    return {
      isFetching: true,
      isError: false,
      errorMessage: null
    }
  },
  mounted () {
    this.handleDownloadPdf()
  },
  methods: {
    async handleDownloadPdf () {
      this.isFetching = true
      let baseUrl
      if (process.env.VUE_APP_ENV === 'prod') {
        baseUrl = 'https://export.yezza.io'
      } else {
        baseUrl = 'https://export-test.yezza.io'
      }
      // Url setup
      let url = `${baseUrl}/purchases/${this.$attrs.slug}/quotations/${this.$attrs.pid}/preview_document`
      url = new URL(url)
      // Set params
      url.searchParams.set('pid', true)
      // Download
      try {
        await this.$axios.get(url)
        window.open(url, '_self')
      } catch (error) {
        if (error.response && error.response.status === 404) {
          this.errorMessage = 'Quotation Request not found'
        } else {
          this.errorMessage = 'Unable to complete request. Please try again later'
        }
        this.isError = true
        return
      } finally {
        this.isFetching = false
      }
    },
  },
}
</script>

<style scoped>
</style>